import React, { useState, useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import {
  Grid,
  Modal,
  Backdrop,
  Fade,
  makeStyles,
  Button,
  CircularProgress,
  ButtonGroup,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import api from "../../URL/axiosConfig";

// Components
import PageTitle from "../../components/PageTitle";
import AddGateway from "./AddGateway";
import EditGateway from "./EditGateway";
import ModalViewStat from "./ModalViewStat";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper2: {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "40%",
    outline: "none", // Menghapus outline focus default browser
    borderRadius: "8px",
  },
}));

function Gateway() {
  const classes = useStyles();

  // STATE BARU UNTUK STATISTIK
  const [openStat, setOpenStat] = useState(false);
  const [selectedStatId, setSelectedStatId] = useState(null);

  // State Management
  const [data, setData] = useState([]);
  const [isBusy, setBusy] = useState(false);

  // Modal States
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  // Fungsi Fetch Data
  const fetchData = async () => {
    setBusy(true);
    try {
      const res = await api("/gateway");
      const rawData = res.data.raw || [];
      setData(rawData);
    } catch (error) {
      console.error("Error fetching gateways:", error);
    } finally {
      setBusy(false);
    }
  };
  const handleViewStat = rowData => {
    // Asumsi rowData punya id, misal gateway_id atau id
    setSelectedStatId(rowData.gateway_id || rowData.id);
    setOpenStat(true);
  };
  // Initial Load
  useEffect(() => {
    fetchData();
  }, []);

  // Handlers
  const handleEditClick = rowData => {
    setSelectedData(rowData);
    setOpenEdit(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    fetchData(); // Refresh data setelah add (opsional, tergantung logic di child)
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedData({});
    fetchData(); // Refresh data setelah edit
  };

  // Konfigurasi Kolom Table
  const columns = useMemo(
    () => [
      {
        name: "gateway_name",
        label: "Gateway Name",
        options: { filter: true, sort: true },
      },
      {
        name: "type",
        label: "Type",
        options: { filter: true, sort: true },
      },
      {
        name: "gateway_id",
        label: "Gateway Id",
        options: { filter: true, sort: true },
      },
      {
        name: "weiots_middleware",
        label: "Middleware",
        options: {
          filter: true,
          sort: true,
          // Mengambil nested object property dengan aman
          customBodyRender: value => value?.name || "-",
        },
      },
      {
        name: "location",
        label: "Location",
        options: { filter: true, sort: false },
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => (value === true ? "Active" : "Inactive"),
        },
      },
      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta) => {
            const rowData = data[tableMeta.rowIndex];
            return (
              <ButtonGroup variant="contained" size="small">
                <Button
                  color="secondary"
                  onClick={() => handleEditClick(rowData)}
                >
                  Edit
                </Button>
                {/* TOMBOL BARU STATISTIK */}
                <Button
                  style={{ backgroundColor: "#1890FF", color: "white" }} // Warna biru
                  onClick={() => handleViewStat(rowData)}
                >
                  Stat
                </Button>
              </ButtonGroup>
            );
          },
        },
      },
    ],
    [data],
  ); // Re-calculate columns jika data berubah

  return (
    <>
      <PageTitle
        title="Gateway"
        button="Add Gateway"
        modal={() => setOpenAdd(true)}
      />
      <ModalViewStat
        open={openStat}
        onClose={() => setOpenStat(false)}
        dataId={selectedStatId} // ID untuk fetch data di dalam modal
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title={"Gateway List"}
            data={data}
            columns={columns}
            options={{
              filter: true,
              selectableRows: "multiple",
              filterType: "dropdown",
              responsive: "vertical",
              rowsPerPage: 10,
              textLabels: {
                body: {
                  noMatch: isBusy ? (
                    <CircularProgress />
                  ) : (
                    "Sorry, there is no matching data to display"
                  ),
                },
              },
              onSearchChange: () => setBusy(false), // Menjaga UI tetap responsif saat search
            }}
          />
        </Grid>
      </Grid>

      {/* Modal Add */}
      <Modal
        className={classes.modal}
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={openAdd}>
          <div className={classes.paper2}>
            <AddGateway onclose={handleCloseAdd} />
          </div>
        </Fade>
      </Modal>

      {/* Modal Edit */}
      <Modal
        className={classes.modal}
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={openEdit}>
          <div className={classes.paper2}>
            {/* Pastikan EditGateway menerima prop data */}
            <EditGateway data={selectedData} onclose={handleCloseEdit} />
          </div>
        </Fade>
      </Modal>
    </>
  );
}

export default withRouter(Gateway);
